module.exports = __webpack_public_path__ + "svg/flag-defs.svg";